<template>
  <div>
    <div v-if="pdfUrl" color="primary" :style="this.$mq==='sp' ? 'margin: 5px;' : 'margin: 20px;'">
      <vue-pdf-embed key="mainPdf" :style="`${!showVertically && 'display: flex;'}overflow: scroll; background-color: #ffffff`" :width="showVertically ? undefined : this.$mq==='sp' ? 300 : 600" :source="pdfUrl" />
    </div>
    <!-- PDFのダウンロードボタン -->
    <div v-if="pdfUrl" style="display:flex; justify-content:center; align-items: center;">
      <v-btn
        class=""
        color="#707070"
        rounded
        width="200"
        @click="downloadPdf"
      >
        <v-icon color="#FFFFFF" size="19">mdi-download </v-icon>
        <!-- 白字でダウンロード -->
        <span style="color: white;">PDFをダウンロード</span>
      </v-btn>
    </div>
    <div v-if="isAdmin" style="display:flex; justify-content:center; align-items: center;">
      <div v-if="isAdmin && pdfUrl" style="display:flex; justify-content:center; align-items: center; flex-wrap: wrap;">
        <v-btn
          class=""
          color="#E64550"
          rounded
          width="200"
          @click="deletePdf"
        >
          <v-icon color="#FFFFFF" size="19">mdi-delete </v-icon>
          <!-- 白字で削除 -->
          <span style="color: white;">PDFを削除</span>
        </v-btn>
      </div>
      <v-btn
        class="mx-4"
        color="#707070"
        rounded
        width="200"
      >
        <label class="input-item__label" >
          <v-icon color="#FFFFFF" size="19">mdi-upload </v-icon>
          {{ uploading
            ? 'アップロード中'
            : pdfUrl
              ? 'PDFを更新'
              : 'PDFを追加'
          }}
          <!-- ローディング -->
          <v-progress-circular
            v-if="uploading"
            indeterminate
            color="white"
            size="20"
            class="ml-2"
          />
          <input type="file" @change="onFileChange" :disabled="uploading" />
        </label>
      </v-btn>
      ※10MB程度を目安としてください。
      <v-checkbox
        v-if="pdfUrl"
        v-model="showVertically"
        @click="onVerticalChange"
        label="縦表示"
        color="#707070"
        class="mt-2"
      />
    </div>
    <pdfReaderTemp style="z-index: 1"/>
  </div>
</template>

<script>
import Vue from 'vue'
import firebase from 'firebase'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import axios from "axios";
import VueMq from 'vue-mq'
import VueAxios from "vue-axios";
import pdfReaderTemp from'./pdfReaderTemp.vue'

Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 959,
    pc: 960
  },
  defaultBreakpoint: 'pc' // customize this for SSR
})
Vue.use(VueAxios, axios)

const thisEnvId = process.env.VUE_APP_TEMP_CITY_ID || ''
export default {
  components: {
    VuePdfEmbed,
    pdfReaderTemp,
  },
  props: ['lidId', 'wsId', 'pageType', 'append'],
  data: () => ({
    loading: true,
    pdfUrl: '',
    contentEditing: '',
    add: false,
    uploading: false,
    showVertically: false,
  }),
  created() {
    this.getContent()
  },
  computed: {
    pageId() {
      return this.pageType.startsWith('sp_') ? this.pageType.slice(3) : this.pageType
    },
    isSp() {
      return this.$mq === "sp";
    },
    isAdmin() {
      return !this.isSp && (this.$store.state.isAdmin||(this.aboutLid&&this.aboutLid.lidAdmin&&this.aboutLid.lidAdmin.includes(this.$store.state.auth?.user?.uid || '')))
    },
    lid(){
      return this.$store.state.lid
    },
    alid(){
      return this.$store.state.alid
    },
    aboutLid() {
      if (this.$store.state.lid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.lid.filter((u) => u.id === this.$route.params.id)[0]
        } else if (this.$store.state.alid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.alid.filter((u) => u.id === this.$route.params.id)[0]
        } else {
          return null
        }
    },
  },
  methods: {
    getContent: async function() {
      const self = this
      let filepath = `contents/${this.lidId||'home'}/${this.pageId}${this.append || ''}.pdf`
      if(this.lidId === 'ws') filepath = `contents/ws/${this.wsId}/${this.pageId}${this.append || ''}.pdf`
      // console.log(filepath)
      const ref = await firebase.storage().ref(filepath);
      
      // ダウンロードURLを取得
      await ref.getDownloadURL()
        .then((downloadLink) => {
          self.pdfUrl = downloadLink
          ref.getMetadata()
            .then((metadata) => {
              // console.log(metadata)
              self.showVertically = metadata.customMetadata.showVertically === 'true'
            })
            .catch((error) => {
              console.error(error);
            });
        })
        .catch((error) => {
          console.error(error);
        });
      self.loading = false;
    },

    onFileChange: async function(e) {
      this.uploading = true
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      let filepath = `contents/${this.lidId||'home'}/${this.pageId}${this.append || ''}.pdf`
      if(this.lidId === 'ws') filepath = `contents/ws/${this.wsId}/${this.pageId}${this.append || ''}.pdf`
      // console.log(filepath)
      const ref = await firebase.storage().ref(filepath);
      ref.put(files[0])
        .then((snapshot) => {
          ref.updateMetadata({
            customMetadata: {
              showVertically: this.showVertically ? 'true' : 'false',
            }
          })
          this.getContent()
          this.uploading = false
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onVerticalChange: async function() {
      let filepath = `contents/${this.lidId||'home'}/${this.pageId}${this.append || ''}.pdf`
      if(this.lidId === 'ws') filepath = `contents/ws/${this.wsId}${this.append || ''}.pdf`
      // console.log(filepath)
      const ref = await firebase.storage().ref(filepath);
      ref.updateMetadata({
        customMetadata: {
          showVertically: this.showVertically ? 'true' : 'false',
        }
      })
    },
    downloadPdf: async function() {
      window.open(this.pdfUrl, '_blank')
    },
    deletePdf: async function() {
      let filepath = `contents/${this.lidId||'home'}/${this.pageId}${this.append || ''}.pdf`
      if(this.lidId === 'ws') filepath = `contents/ws/${this.wsId}${this.append || ''}.pdf`
      // console.log(filepath)
      const ref = await firebase.storage().ref(filepath);
      ref.delete()
        .then(() => {
          this.pdfUrl = ''
        })
        .catch((error) => {
          console.error(error);
        });
    },
  }
}

</script>
<style>
/* vue-pdf-embed 直下のdivコンポーネントはmargin 5px */
.vue-pdf-embed > div {
  margin: 2px !important;
}
</style>
<style scoped>
.input-item__label {
  cursor: pointer;
  color:#FFFFFF;
}
.input-item__label input[type="file"] {
  display: none;
}
</style>